
import React from 'react';
import { PageTitle, Card, Button } from '../components/common';

const ReferralsPage: React.FC = () => {
    return (
        <div>
            <PageTitle title="Referrals" subtitle="Invite friends and earn rewards on EdJAMON." />
            <Card className="p-6 text-center">
                <h2 className="text-xl font-bold text-gray-800">Share the love of learning!</h2>
                <p className="mt-2 text-gray-600">
                    Share your unique referral link with friends. When they sign up, you both get a discount on your next course.
                </p>
                <div className="my-6">
                    <p className="text-sm text-gray-500 mb-2">Your referral link</p>
                    <div className="flex justify-center">
                        <input 
                            type="text" 
                            readOnly 
                            value="https://edjamon.com/ref/ronald123" 
                            className="w-full max-w-md p-3 border border-gray-300 rounded-l-lg bg-gray-50 text-center"
                        />
                        <Button className="rounded-l-none">Copy Link</Button>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default ReferralsPage;
